import { combineActions, handleActions } from 'redux-actions';
import { trustpilot as actions } from '../../../actions';

const initialState = {
  inProgress: true,
  isLogged: false,
};

const trustpilot = handleActions<any, any>({
  [combineActions(
    actions.getLoggedStatus,
    actions.setLoggedStatus,
  ) as any]: (state: any, action: any): any => ({
    ...state,
    ...action.payload,
  }),
}, initialState);

export default trustpilot;
